import { useRef, useEffect, useState } from "react";
import styles from "./Video.module.css";
import { FaPlay, FaCircle, FaPause } from "react-icons/fa";

const API_ENDPOINT = process.env.REACT_APP_IMAGE_HANDLER_URL;
const IMAGE_BUCKET = process.env.REACT_APP_IMAGE_BUCKET;

function getImageUrl(key, width) {
  const imageRequest = {
    bucket: IMAGE_BUCKET,
    key, // e.g. "images/homepage/video-poster.png"
    edits: {
      resize: {
        width,
        fit: "inside",
      },
      webp: {
        quality: 80,
      },
    },
  };

  const encoded = btoa(JSON.stringify(imageRequest));
  return `${API_ENDPOINT}/${encoded}`;
}

export default function Video() {
  const ref = useRef(null);
  const [key, setKey] = useState(0);
  const [isPaused, setIsPaused] = useState(true);

  const [posterUrl, setPosterUrl] = useState("");

  useEffect(() => {
    setKey((prev) => prev + 1);
  }, [isPaused]);

  // Responsive poster image handling
  useEffect(() => {
    const updatePoster = () => {
      const w = window.innerWidth || 1280;
      let targetWidth;
      if (w <= 640) targetWidth = 640;
      else if (w <= 1024) targetWidth = 1024;
      else targetWidth = 1440;

      // Set the poster URL based on the target width
      setPosterUrl(
        getImageUrl("images/homepage/video-poster.png", targetWidth)
      );
    };

    updatePoster();
    window.addEventListener("resize", updatePoster);
    return () => window.removeEventListener("resize", updatePoster);
  }, []);

  return (
    <section className={styles.videoSection}>
      <header className={styles.titleSection}>
        <h2 className={styles.title}>
          AI Automation: The Future of Compliance
        </h2>
        <p className={styles.subtitle}>
          A peek into how we revolutionize credentialing.
        </p>
      </header>

      <figure className={styles["hero-video-container"]}>
        <video
          ref={ref}
          controls
          className={styles.heroVideo}
          onPlay={() => setIsPaused((prev) => !prev)}
          onPause={() => setIsPaused((prev) => !prev)}
          poster={posterUrl || undefined}
        >
          <source
            src="https://ihs-frontend-videos-and-assets.s3.us-east-2.amazonaws.com/home-page.mp4"
            type="video/mp4"
          />
          Your browser does not support the video
        </video>

        <FaPlay
          size={25}
          className={`${styles.PlayPauseIcon} ${isPaused ? styles.show : ""}`}
          aria-hidden="true"
        />
        <FaPause
          size={25}
          className={`${styles.PlayPauseIcon} ${isPaused ? "" : styles.show}`}
          aria-hidden="true"
        />
        <FaCircle
          key={key}
          size={100}
          className={`${styles.PlayPauseIconBG} ${styles.show}`}
          aria-hidden="true"
        />
      </figure>
    </section>
  );
}
